import { gql, useLazyQuery } from '@apollo/client';

export const GET_WHATS_APP_CAMPAIGN_QUICK_REPLIES_QUERY = gql`
  query getWhatsAppCampaignQuickReplies($id: Long!) {
    templateAndContent(id: $id) {
      ... on TemplateAndContent {
        primaryContent {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            buttons {
              ... on QuickReplyButton {
                buttonText
                title
              }
            }
          }
        }
        localeContents {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            buttons {
              ... on QuickReplyButton {
                buttonText
                title
              }
            }
          }
        }
      }
    }
}`;

export const useGetWhatsAppCampaignQuickReplies = () => {
  const [fetchWhatsAppCampaignQuickReplies, { data = {}, error, loading }] = useLazyQuery(
    GET_WHATS_APP_CAMPAIGN_QUICK_REPLIES_QUERY,
  );

  const handleFetchWhatsAppCampaignQuickReplies = (id: number) => {
    fetchWhatsAppCampaignQuickReplies({ variables: { id } });
  };

  return {
    fetchWhatsAppCampaignQuickReplies: handleFetchWhatsAppCampaignQuickReplies,
    data,
    isLoading: loading,
    error,
  };
};
